// src/lib/supabaseClient.ts
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  throw new Error(
    "Faltan variables de entorno: VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY. Agrégalas en .env (prefijo VITE_) y reinicia."
  );
}

export const SUPABASE_URL = url;

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,          // 👈 importante para no “perder” el login
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
